/**
 * Extract image file extension from a URL pathname.
 * Handles presigned S3 URLs (with query params) and plain paths.
 * Returns 'png' as safe default when extension cannot be determined.
 */
export const getImageExtFromUrl = (src?: string): string => {
    if (!src) return 'png';
    // Data URLs carry the format in the mime type, not in a pathname — a canvas item
    // that was just added from a File is a `data:image/jpeg;base64,…`, and parsing it
    // as a path would fall through to the png default.
    if (src.startsWith('data:image/')) {
        const mimeSubtype = src.slice('data:image/'.length).split(/[;,]/)[0].toLowerCase();
        if (mimeSubtype === 'jpeg' || mimeSubtype === 'jpg') return 'jpg';
        if (mimeSubtype === 'webp') return 'webp';
        return 'png';
    }
    try {
        const pathname = new URL(src).pathname.toLowerCase();
        if (pathname.endsWith('.jpg') || pathname.endsWith('.jpeg')) return 'jpg';
        if (pathname.endsWith('.webp')) return 'webp';
    } catch {
        const lower = src.toLowerCase();
        if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) return 'jpg';
        if (lower.endsWith('.webp')) return 'webp';
    }
    return 'png';
};
